/**
 * Application Entry Point
 * Renders the root App component with design system styles
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App-new';
import './styles/design-system.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
